import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useState } from 'react';
import { OverlayTrigger } from 'ui';
import { BookerContext } from '../Booker.js';
import Field from './Field.js';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
function LoyaltyPlanSelector(props) {
    var _a;
    const { loyaltyPlanList, value } = props;
    const [isOpen, setIsOpen] = useState(false);
    const { vertical, useTailwindPrefix, version, showArrows } = useContext(BookerContext);
    const intl = useIntl();
    function onToggle(data) {
        setIsOpen(data);
        if (data) {
            if (document && document.body) {
                let orig = document.body.className;
                if (!useTailwindPrefix) {
                    if (orig.indexOf('fixed md:relative') < 0) {
                        document.body.className = orig + (orig ? ' ' : '') + 'fixed md:relative';
                    }
                }
                else {
                    if (orig.indexOf('tw-fixed md:tw-relative') < 0) {
                        document.body.className = orig + (orig ? ' ' : '') + 'tw-fixed md:tw-relative';
                    }
                }
            }
        }
        else {
            if (document && document.body) {
                if (!useTailwindPrefix) {
                    document.body.className = document.body.className.replace(/ ?fixed md:relative/, '');
                }
                else {
                    document.body.className = document.body.className.replace(/ ?tw-fixed md:tw-relative/, '');
                }
            }
        }
    }
    function drawSelection(data) {
        var _a;
        let result;
        let selectedLoyaltyPlan = data.find((item) => item.id === (value === null || value === void 0 ? void 0 : value.loyaltyPlanId));
        if (selectedLoyaltyPlan) {
            const selectedPromoCode = (_a = selectedLoyaltyPlan.promotionCodes) === null || _a === void 0 ? void 0 : _a.find((code) => {
                if (value === null || value === void 0 ? void 0 : value.promotionCode) {
                    return code.promotionCode === (value === null || value === void 0 ? void 0 : value.promotionCode);
                }
            });
            if (selectedPromoCode) {
                result = selectedPromoCode.name;
            }
            else {
                result = selectedLoyaltyPlan.name;
            }
        }
        if (result) {
            return (_jsx("div", Object.assign({ className: classNames({
                    'flex justify-between items-center w-full': !useTailwindPrefix,
                    'tw-flex tw-justify-between tw-items-center tw-w-full': useTailwindPrefix,
                    relative: true,
                }) }, { children: _jsx("div", Object.assign({ className: classNames({ ' truncate': !useTailwindPrefix, 'tw-truncate': useTailwindPrefix }) }, { children: result })) })));
        }
        else {
            return intl.formatMessage({ id: 'booker.selectPlan' });
        }
    }
    function closeSelector() {
        onToggle(false);
    }
    function renderOptions(item, index, array) {
        const onClickLoyaltyPlan = (planId) => {
            if (planId.promotionCode) {
                props.onSelect({ promotionCode: planId.promotionCode, loyaltyPlanId: item.id });
            }
            else {
                props.onSelect({ loyaltyPlanId: item.id });
            }
            closeSelector();
        };
        let result = [];
        if (array.length > 1 && item.promotionCodes.length > 0) {
            result.push(_jsx("div", Object.assign({ className: classNames({
                    'overflow-hidden': !useTailwindPrefix,
                    'tw-overflow-hidden': useTailwindPrefix,
                }) }, { children: _jsxs("div", Object.assign({ onClick: () => onClickLoyaltyPlan({ loyaltyPlanId: item.id }), className: classNames({
                        'flex cursor-pointer justify-between items-center py-3 px-5 whitespace-nowrap overflow-hidden text-ellipsis bg-[#EEEEEE] hover:bg-neutral-100 gap-x-4': !useTailwindPrefix,
                        'tw-flex tw-cursor-pointer tw-justify-between tw-items-center tw-py-3 tw-px-5 tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis tw-bg-[#EEEEEE] hover:tw-bg-neutral-100 tw-gap-x-4': useTailwindPrefix,
                    }) }, { children: [item.name, _jsx("span", Object.assign({ className: classNames({
                                'text-xs text-link-blue': !useTailwindPrefix,
                                'tw-text-xs tw-text-link-blue': useTailwindPrefix,
                            }) }, { children: intl.formatMessage({ id: 'booker.selectPlan' }) }))] })) }), item.id));
        }
        let promotionsCodes = [...item.promotionCodes].sort((a, b) => (a.order > b.order ? 1 : -1));
        result.push(_jsx("div", Object.assign({ className: classNames({
                block: !useTailwindPrefix,
                'tw-block': useTailwindPrefix,
            }) }, { children: promotionsCodes.map((ratePlan, index) => {
                return (_jsx("div", Object.assign({ className: classNames({
                        'overflow-hidden cursor-pointer w-full': !useTailwindPrefix,
                        'tw-overflow-hidden tw-cursor-pointer tw-w-full': useTailwindPrefix,
                    }), onClick: () => onClickLoyaltyPlan({ loyaltyPlanId: item.id, promotionCode: ratePlan.promotionCode }) }, { children: _jsx("div", Object.assign({ className: classNames({
                            'block py-5 px-5 whitespace-nowrap overflow-hidden text-ellipsis hover:bg-gray-100 cursor-pointer': !useTailwindPrefix,
                            'tw-block tw-py-3 tw-px-5 tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis hover:tw-bg-gray-100 tw-cursor-pointer': useTailwindPrefix,
                        }) }, { children: ratePlan.name })) }), `ratePlans-${item.id}-${index}`));
            }) }), `ratePlans-${item.id}-${index}`));
        return result;
    }
    return (_jsxs(OverlayTrigger, Object.assign({ isOpen: isOpen, onToggle: onToggle }, { children: [_jsx(OverlayTrigger.Trigger, Object.assign({ componentTag: "div", className: classNames({
                    'cursor-pointer': !useTailwindPrefix,
                    'tw-cursor-pointer': useTailwindPrefix,
                }) }, { children: _jsx(Field, { children: _jsx("div", Object.assign({ className: classNames({
                            'whitespace-nowrap w-full overflow-hidden text-ellipsis': !useTailwindPrefix,
                            'tw-whitespace-nowrap w-full tw-overflow-hidden tw-text-ellipsis': useTailwindPrefix,
                        }) }, { children: loyaltyPlanList.isFetching ? '...' : drawSelection((loyaltyPlanList === null || loyaltyPlanList === void 0 ? void 0 : loyaltyPlanList.data) || []) })) }) })), _jsxs(OverlayTrigger.Overlay, Object.assign({ className: classNames({
                    'md:rounded-widget-pill-overlays-border-radius': !useTailwindPrefix && !vertical && version === 'padded',
                    'md:tw-rounded-widget-pill-overlays-border-radius': useTailwindPrefix && !vertical && version === 'padded',
                    'itm-popover-withArrow before:left-5 after:hidden md:mt-[25px]': !useTailwindPrefix && showArrows,
                    'itm-popover-withArrow before:tw-left-5 after:tw-hidden md:tw-mt-[25px]': useTailwindPrefix && showArrows,
                    'md:mt-0.5': !useTailwindPrefix && !showArrows,
                    'md:tw-mt-0.5': useTailwindPrefix && !showArrows,
                    'bg-white md:border border-gray-200 z-10 fixed inset-0 md:shadow-lg md:absolute md:min-w-[280px]': !useTailwindPrefix,
                    'tw-bg-white md:tw-border tw-border-gray-200 tw-z-10 tw-fixed tw-inset-0 md:tw-shadow-lg md:tw-absolute md:tw-min-w-[280px]': useTailwindPrefix,
                    'md:inset-auto': !vertical && !useTailwindPrefix,
                    'md:tw-inset-auto': !vertical && useTailwindPrefix,
                    'md:inset-y-auto md:left-auto md:right-0': vertical && !useTailwindPrefix,
                    'md:tw-inset-y-auto md:tw-left-auto md:tw-right-0': vertical && useTailwindPrefix,
                }) }, { children: [_jsxs("div", Object.assign({ className: classNames({
                            'md:hidden flex overflow-auto justify-between items-center px-4 border-b border-gray-200 h-[50px]': !useTailwindPrefix,
                            'md:tw-hidden tw-flex tw-overflow-auto tw-justify-between tw-items-center tw-px-4 tw-border-b tw-border-gray-200 tw-h-[50px]': useTailwindPrefix,
                        }) }, { children: [_jsx("div", Object.assign({ className: classNames({ 'text-3xl': !useTailwindPrefix, 'tw-text-3xl': useTailwindPrefix }) }, { children: intl.formatMessage({ id: 'booker.loyaltyPlans' }) })), _jsx("button", Object.assign({ type: "button", onClick: closeSelector, className: classNames({
                                    'cursor-pointer text-2xl': !useTailwindPrefix,
                                    'tw-cursor-pointer tw-text-2xl': useTailwindPrefix,
                                }) }, { children: _jsx(FontAwesomeIcon, { icon: faTimes }) }))] })), _jsx("div", Object.assign({ className: classNames({
                            'md:rounded-widget-pill-overlays-border-radius-inner': !useTailwindPrefix && !vertical && version === 'padded',
                            'md:tw-rounded-widget-pill-overlays-border-radius-inner': useTailwindPrefix && !vertical && version === 'padded',
                            'fixed overflow-auto inset-0 top-[50px] md:inset-auto md:relative': !useTailwindPrefix,
                            'tw-fixed tw-overflow-auto tw-inset-0 tw-top-[50px] md:tw-inset-auto md:tw-relative': useTailwindPrefix,
                        }) }, { children: (_a = loyaltyPlanList === null || loyaltyPlanList === void 0 ? void 0 : loyaltyPlanList.data) === null || _a === void 0 ? void 0 : _a.filter((rate) => rate.hasPointBenefit && rate.promotionCodes.length > 0).sort((a, b) => (a.order > b.order ? 1 : -1)).map(renderOptions) }))] }))] })));
}
LoyaltyPlanSelector.propTypes = {};
export default LoyaltyPlanSelector;
